<template>
      <i><em>.</em> <em>.</em> <em>.</em></i>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  @keyframes bounce {
  from,
  6.66%,
  17.66%,
  26.66%,
  33.66% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%,
  14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -24%, 0);
  }

}
u {text-decoration: none;}
em {
  display: inline-block;
  animation-name: bounce;
  transform-origin: center bottom;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  &:nth-child(2) {
    animation-delay: .13s;
  }
  &:nth-child(3) {
    animation-delay: 0.26s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/DotsLoader.vue